<script>
  import axios from "axios"
  import Navbar from "../../../Shared/Navbar/index.svelte"
  import Footer from "../../../Shared/footer.svelte"
  import Table from "../../../Shared/Table/table.svelte"
  import List from "./Components/list.svelte"
  import ApplicationState from "../../../Stores/applicationStates"
  import { onMount } from "svelte"
  import { push, querystring } from "svelte-spa-router"
  import notify from "../../../Script/notify"
  import { queryStringToJSON } from "../../../Script/queryString"
  import LoadingScreen from "../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import FilterComponent from "../Document/Components/filterComponent.svelte"
  import { getRequest } from "../../../Script/apiMethods"
  /**
   * @type {Number} - how many list need to show
   */
  let limit
  /**
   * @type {Number} - which page list need to show
   */
  let page
  /**
   * @type {Number} - which order need to show (in order to date)
   */
  let sort
  /**
   * @typedef {Object} search - it contains what user want to search (searchvalue) in which parameter (searchParam)
   * @type {Object}
   * it contains what user want to search (searchvalue) in which parameter (searchParam)
   *
   * @property {String} searchvalue - what value need to search.
   * @property {String} searchParam - on which param need to show
   */
  let search = {
    searchParam: "name",
    searchvalue: "",
  }
  /**
   * @type {String} - from date of filter list
   */
  let startDate = null
  /**
   * @type {String} - to date of filter list
   */
  let endDate = null
  /**
   * @type {String} - which state document need to show
   */
  let status = null
  /**
   * @type {Object} stores the query value in current location url
   */
  let query
  /**
   * @type {Object} - response for fetch document api call
   */
  let DocumentList = {
    documents: [],
  }
  /**
   * @type {Boolean} for showing Loader while loading the list of Email templates
   */
  let showLoading = false
  /**
   * @type {Number} -which sory type need to show (date or name)
   */
  let sortBy

  onMount(async () => {
    try {
      query = queryStringToJSON($querystring)
      limit = query.limit ? query.limit : 10
      page = query.page ? query.page : 1
      sort = query.sort ? query.sort : -1
      sortBy = query.sortBy ? query.sortBy : "date"
      if (query.sdate) startDate = query.sdate
      if (query.edate) endDate = query.edate
      if (query.state) status = query.state
      if (query.sname) search.searchvalue = query.sname
      await fetchBulkDocuments()
    } catch (error) {
      const info = "PAGE: Badge List\nEVENT: onMount"
      notify.danger(error, info)
    }
  })

  /**
   * @description function for fetch bulk publsih process documents.
   */
  const fetchBulkDocuments = async () => {
    try {
      showLoading = true
      const { bulkUploads, count } = await getRequest(`/api/swagger/v2/bulk?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}${status ? `&state=${status}` : ``}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      DocumentList.documents = [...bulkUploads]
      DocumentList.count = count
      push(`/documents/bulk?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}${status ? `&state=${status}` : ``}`)
    } catch (error) {
      throw error
    } finally {
      showLoading = false
    }
  }

  /**
   * @description Function to fetch templates based on user input.
   */
  const whileChangeingEntries = async (e) => {
    try {
      if (e.detail.entries) limit = e.detail.entries
      if (e.detail.activePage) page = e.detail.activePage
      if (e.detail.sort) sort = e.detail.sort
      if (e.detail.sortBy) sortBy = e.detail.sortBy
      if (e.detail.filter.date.status) {
        status = e.detail.filter.date.status
        startDate = e.detail.filter.date.startDate ? e.detail.filter.date.startDate : ""
        endDate = e.detail.filter.date.endDate ? e.detail.filter.date.endDate : ""
      }
      if (e.detail.filter.search.searchParam) {
        search.searchParam = e.detail.filter.search.searchParam
        search.searchvalue = e.detail.filter.search.searchvalue
      }
      await fetchBulkDocuments()
    } catch (error) {
      const info = "PAGE: Bulk Session List\nEVENT: Error occurred during actions such as sorting by date/ name, changing display entries, changing date filter, searching by name/ id/ status, or navigating pages."
      notify.danger(error, info)
    }
  }

  /**
   * @description Function to reset the user inputs
   */
  const resetList = async () => {
    try {
      limit = 10
      page = 1
      sort = -1
      sortBy = "date"
      search.searchvalue = ""
      startDate = ""
      endDate = ""
      status = "active"
      await fetchBulkDocuments()
    } catch (error) {
      const info = "PAGE: Bulk Session List\nEVENT: Error occurred while resetting filter."
      notify.danger(error, info)
    }
  }
</script>

<svelte:head>
  <title>Bulk Documents</title>
</svelte:head>

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  {#if showLoading}
    <LoadingScreen msg="Fetching Bulk Document list" />
  {/if}
  <div class="px-6">
    <div class="relative mx-auto mb-40 mt-10 h-full w-full max-w-[920px]">
      <!-- <div class="relative mx-auto mb-40 mt-10 h-fit w-full px-6 md:w-4/5 md:px-0 xl:w-3/5"> -->
      <Table on:changeEntries={whileChangeingEntries} on:resetEntries={resetList} title="List of Bulk Sessions" filterComponent={FilterComponent} count={DocumentList.count} jsonData={DocumentList.documents} filter={true} bulkStatus={true} searchparam={false}>
        {#if DocumentList.documents.length}
          {#each DocumentList.documents as json}
            <List {json} />
          {/each}
        {:else}
          <div class="select-none rounded-md bg-white py-6 text-center text-2xl text-black dark:bg-darkgray dark:text-white">There is no bulk Document</div>
        {/if}
      </Table>
    </div>
  </div>
  <Footer />
</div>
